import { ThemeProvider } from 'styled-components';
import { ConfigProvider } from 'antd';
import theme from './theme';
import GlobalStyle from './global';

export const StylesProvider = ({ children }) => {
  return (
    <ThemeProvider theme={theme.styled}>
      <ConfigProvider theme={theme.ant}>
        <GlobalStyle />
        {children}
      </ConfigProvider>
    </ThemeProvider>
  );
};
